var _path, _g, _path2, _g2, _path3, _g3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHandSpiral(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 236,
    height: 133,
    viewBox: "0 0 236 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M224.332 38.9592C225.537 43.6938 224.053 49.0828 219.901 54.8979C215.755 60.7057 209.064 66.7581 200.265 72.6807C182.678 84.5181 156.951 95.6483 127.254 103.206C97.5572 110.764 69.6394 113.286 48.5334 111.296C37.9735 110.3 29.2036 108.183 22.785 105.064C16.3583 101.941 12.4795 97.9165 11.2746 93.1818C10.0696 88.4472 11.5527 83.0583 15.7047 77.2431C19.8514 71.4353 26.5421 65.3829 35.3413 59.4604C52.9282 47.623 78.6553 36.4927 108.352 28.9349C138.049 21.3771 165.967 18.8548 187.073 20.845C197.633 21.8407 206.403 23.9584 212.821 27.0773C219.248 30.2002 223.127 34.2246 224.332 38.9592Z",
    stroke: "white",
    strokeWidth: 3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_163_3022)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181 78.0679C184.666 76.123 187.696 73.1658 189.73 69.5483L190 69.0679C191.748 72.9543 194.824 76.0906 198.675 77.9142L199 78.0679L195.739 80.8142C194.353 81.9807 193.081 83.2754 191.939 84.6809L190 87.0679L188.791 85.4608C187.346 83.5398 185.666 81.8073 183.79 80.304L181 78.0679Z",
    fill: "#EE2924"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M181 78.0679C184.666 76.123 187.696 73.1658 189.73 69.5483L190 69.0679C191.748 72.9543 194.824 76.0906 198.675 77.9142L199 78.0679L195.739 80.8142C194.353 81.9807 193.081 83.2754 191.939 84.6809L190 87.0679L188.791 85.4608C187.346 83.5398 185.666 81.8073 183.79 80.304L181 78.0679Z",
    fill: "#EE2924"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_163_3022)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37 109.594C40.666 107.649 43.6962 104.692 45.7299 101.075L46 100.594C47.748 104.481 50.8237 107.617 54.6753 109.44L55 109.594L51.7385 112.341C50.3533 113.507 49.0812 114.802 47.9393 116.207L46 118.594L44.7912 116.987C43.3461 115.066 41.666 113.334 39.7902 111.83L37 109.594Z",
    fill: "#5165AE"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37 109.594C40.666 107.649 43.6962 104.692 45.7299 101.075L46 100.594C47.748 104.481 50.8237 107.617 54.6753 109.44L55 109.594L51.7385 112.341C50.3533 113.507 49.0812 114.802 47.9393 116.207L46 118.594L44.7912 116.987C43.3461 115.066 41.666 113.334 39.7902 111.83L37 109.594Z",
    fill: "#5165AE"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_163_3022)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.105 24.9626C110.771 23.0177 113.801 20.0605 115.835 16.443L116.105 15.9626C117.853 19.849 120.929 22.9853 124.781 24.8089L125.105 24.9626L121.844 27.709C120.458 28.8754 119.186 30.1701 118.044 31.5757L116.105 33.9626L114.896 32.3556C113.451 30.4345 111.771 28.702 109.895 27.1987L107.105 24.9626Z",
    fill: "#F4EE72"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M107.105 24.9626C110.771 23.0177 113.801 20.0605 115.835 16.443L116.105 15.9626C117.853 19.849 120.929 22.9853 124.781 24.8089L125.105 24.9626L121.844 27.709C120.458 28.8754 119.186 30.1701 118.044 31.5757L116.105 33.9626L114.896 32.3556C113.451 30.4345 111.771 28.702 109.895 27.1987L107.105 24.9626Z",
    fill: "#F4EE72"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_163_3022",
    x: 174.28,
    y: 62.3479,
    width: 31.4399,
    height: 31.4399,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.35998,
    result: "effect1_foregroundBlur_163_3022"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_163_3022",
    x: 30.28,
    y: 93.8742,
    width: 31.4399,
    height: 31.4399,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.35998,
    result: "effect1_foregroundBlur_163_3022"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_163_3022",
    x: 100.385,
    y: 9.24263,
    width: 31.4399,
    height: 31.4399,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.35998,
    result: "effect1_foregroundBlur_163_3022"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandSpiral);
export default __webpack_public_path__ + "static/media/handSpiral.6180a264d95e0e0aa0426cb4250ddf16.svg";
export { ForwardRef as ReactComponent };